import { createContext } from 'react';
import { Config } from './config.model';

export type ConfigContextType = {
    config: Config;
    addFavouriteResource: (id: string) => void;
    removeFavouriteResource: (id: string) => void;
}

export const ConfigContext = createContext<ConfigContextType>(null);